/**
 * 阿里云实时语音合成配置
 */
export const ALIYUN_CONFIG = {

    // WebSocket地址
    WS_URL: "wss://nls-gateway-cn-beijing.aliyuncs.com/ws/v1",

    // 默认音频格式
    FORMAT: "pcm",

    // 默认采样率
    SAMPLE_RATE: 16000,

    // 默认音色（CosyVoice大模型）
    VOICE: "longxiaochun",//cosyvoice-v2-voiceofxu-4df48c8   longxiaochun

    // 默认语言
    LANGUAGE: "zh-CN",

    // 是否开启标点
    ENABLE_PUNCTUATION: true

};

/**
 * 许鹏飞医生专属音色
 */
export const COSYVOICE_VOICE_XU = "cosyvoice-v2-voiceofxu-4df48c8";

/**
 * 许鹏飞医生专属音色的语速
 * 阿里云 speech_rate 范围：-500 ~ 500，0 为默认语速
 * 换算参考：speech_rate ≈ (目标语速 / 默认语速 - 1) * 500，负数放慢、正数加快
 * 当前 -50 约为 0.9 倍速（略慢），如需调整直接改这里即可
 */
export const COSYVOICE_VOICE_XU_SPEECH_RATE = 150;